var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center align-center fill-height"},[_c('c-btn',{attrs:{"small":"","color":_vm.buttonColor}},[_vm._v(_vm._s(_vm.$t('actions.show_details')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }